import log from 'salvo-lite/log'

class ReadMore {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }

    onInit () {
        const readmoreBtn = document.querySelector('.collection__desc-read-more-btn')
        log.debug(this._name, 'Initialised', this)

        readmoreBtn.addEventListener('click', (e) => {
            this._toggleClass(e.target)
        })
    }

    _toggleClass (target) {
        this._elem.classList.toggle('expanded')

        if (target.innerHTML === 'Show More') {
            target.innerHTML = 'Show Less'
        } else {
            target.innerHTML = 'Show More'
        }
    }
}

export default ReadMore



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ReadMore.js